export enum FormTemplateTypeEnum {
    CompetitionLicenceApplication = 1,
    IRDS = 2,
    BRDS = 4,
    Media = 8,
    MinorEntrant = 16,
    OneDayEvent = 32,
    Official = 64,
    Questionnaire = 128
}